import React from "react";

import MiCeluAdminLayout from "../template/admin.layout";

const AgentsAdminHomePage = () => {
  return (
    <MiCeluAdminLayout>
      <div className="flex w-full items-center justify-center">
        <h2 className="text-center text-2xl text-white">
          Bienvenido al panel de adminstración de agentes
        </h2>
      </div>
    </MiCeluAdminLayout>
  );
};

export default AgentsAdminHomePage;
